import RecoverStep from "./recover_step";

const TEMPLATE = 'appliance-offline';

export default class ApplianceOffline extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    transitionTryAgain(data, el, fr) {
        fr.goTo(data.tmp.applianceOffline.tryAgain);
    }

    transitionBack(data, el, fr) {
        if (data.tmp.applianceOffline.back === 'setDevice') {
            delete data.recovery.device_id;
        } else if (data.tmp.applianceOffline.back === 'setDrive') {
            delete data.recovery.drive;
        }
        fr.goTo(data.tmp.applianceOffline.back);
    }

}
